/**
 * megaMenuNav
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_mega-menu-nav.scss';

// Module template
import './_mega-menu-nav.twig';

export const name = 'megaMenuNav';

export const defaults = {
  dummyClass: 'js-megaMenuNav-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { megaMenuNav = {} }) {
  // Find our component within the DOM
  const $megaMenuNav = $('.mega_menu_nav', $context);
  // Bail if component does not exist
  if (!$megaMenuNav.length) {
    return;
  }
  // Merge defaults with incoming settings
  // eslint-disable-next-line no-unused-vars
  const settings = Object.assign(defaults, megaMenuNav);
  // An example of what could be done with this component
  // $megaMenuNav.addClass(settings.dummyClass);
}
// -- Handling  key board tabbing - start -- //
document.querySelectorAll('[role="menubar"]').forEach(menu => {
  const menuItems = menu.querySelectorAll('li');

  menuItems.forEach(item => {
    ['focusin', 'mouseenter'].forEach(eventType => {
      item.addEventListener(eventType, e => {
        // Remove focus from all siblings, so that multiple menu is not open in the same time
        Array.from(item.parentElement.children).forEach(sibling => {
          if (sibling !== item) {
            sibling.classList.remove('focus');
            const link = sibling.querySelector('[role="menuitem"]');
            if (link) link.setAttribute('aria-expanded', 'false');
          }
        });
        // focus the item and display submenu
        item.classList.add('focus');
        const submenuTrigger = item.querySelector('[role="menuitem"]');
        const submenu = item.querySelector('div[role="menu"]');
        if (submenuTrigger && submenu) {
          submenuTrigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    ['focusout', 'mouseleave'].forEach(eventType => {
      item.addEventListener(eventType, e => {
        // settimeout used here to delay execution until the browser knows where focus is
        setTimeout(() => {
          if (!item.contains(document.activeElement)) {
            item.classList.remove('focus');
            const link = item.querySelector('[role="menuitem"]');
            if (link) link.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });
  });
});

// -- Handling  key board tabbing - END -- //
export default enable;
